// extracted by mini-css-extract-plugin
export default {"form":"mfmZdt","uploadInput":"lhvRd2","uploadButton":"aa6Mjx"};